/* eslint-disable react/prop-types */
import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import SpacerLogAiAskBar from '../SpacerLog/SpacerLogAiAskBar';
import '../SpacerLog/SpacerLogDashboard.css';
import './AssistancePage.css';

const readStoredProject = () => {
  try {
    const raw =
      localStorage.getItem('selectedProject') ||
      localStorage.getItem('SelectedProject') ||
      localStorage.getItem('project');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

/**
 * Global Ask Evans route — same full-page layout as Lessons Learned /ask-evans
 * (Chats sidebar + header + token meter). No duplicate page banner.
 */
const AssistancePage = ({ selectedProject }) => {
  const project = selectedProject || readStoredProject();
  const projectId = get(project, 'id');
  const [open, setOpen] = useState(true);
  const context = useMemo(() => ({ projectId }), [projectId]);

  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <div className="ask-evans-page ask-evans-page--fullscreen">
      <SpacerLogAiAskBar
        open={open}
        onOpenChange={setOpen}
        defaultLayout="page"
        context={context}
        activeView="project"
        tabScope="overview"
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  selectedProject:
    get(state, 'projects.selectedProject') ||
    get(state, 'project.selectedProject') ||
    get(state, 'dsr.selectedProject'),
});

export default connect(mapStateToProps)(AssistancePage);
